// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zrvzcsdxbhzwfabvndbo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpydnpjc2R4Ymh6d2ZhYnZuZGJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQyOTI4MTEsImV4cCI6MjA0OTg2ODgxMX0.TItHzffYGA9EsEN88igyVXeHocFdCTbJQOAKi4W07BU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);